import React from 'react';

import { getColorTint, primaryColor, unit } from '@zego/theme';

import Spacer from '@zego/components/atoms/Spacer';
import View from '@zego/components/atoms/View';
import SenseEducationalSection from '@zego/components/SenseEducationalSection';

import SenseCarCheckImage from '@zego/static/svgs/checkmark-car-icon.svg';
import SenseGraphsImage from '@zego/static/svgs/currency-trends-image.svg';
import MobilePhoneImage from '@zego/static/svgs/sense-mobile-phone.svg';

const senseInformationItemsCss = {
  descriptionCss: { color: getColorTint('grey', 7) },
  titleCss: { fontSize: 22 },
};

const SENSE_INFORMATION_ITEMS = [
  {
    image: MobilePhoneImage,
    title: 'Sense is created by you',
    description: 'Tell us more about you and how you drive by using our app.',
    ...senseInformationItemsCss,
  },
  {
    image: SenseCarCheckImage,
    title: 'Drive well, pay less',
    description:
      'The better you drive, the less you’ll have to pay. That makes sense.',
    ...senseInformationItemsCss,
  },
  {
    image: SenseGraphsImage,
    title: 'Technology that’s on your side',
    description:
      'Our app senses your driving over time, smoothing out the odd sharp corner or harsh brake.',
    ...senseInformationItemsCss,
  },
];

const PrivateHireSenseEducationalSection = () => (
  <View>
    <Spacer height={unit(10)} mobileHeight={unit(6)} />
    <SenseEducationalSection
      senseInformationTitle="So we’re changing it. Together."
      senseInformationList={SENSE_INFORMATION_ITEMS}
      backgroundColor={primaryColor(2)}
    />
  </View>
);

export default PrivateHireSenseEducationalSection;
